import angular from 'angular';

import SocketModule from './socket/socket';

const ServicesModule = angular.module('control-room.app.services', [SocketModule.name]);

export default ServicesModule;
